// This file allow importing threejs and co

import * as three from 'three'
export const THREE = three
import { Stats as stats } from 'three-stats/dist/index'
export const Stats = stats
